import api from './config';

export default function getTickets(params = {}) {
  return api('/Tickets', { params });
}
